var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141.7 147.6",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.5,15.6c4.7,4.7,4.7,12.4,0,17.2l-6.1,6.1l-21.2-21.2l6.1-6.1c4.7-4.7,12.4-4.7,17.2,0L133.5,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,73.2l21.2,21.2l-0.2,0.2l-29.4,8.1l8.1-29.4L50.6,73.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.8,91.5c-1.9,0-3.5,1.6-3.5,3.5v30.8c0,5.7-4.7,10.4-10.4,10.4H18.6c-5.7,0-10.4-4.7-10.4-10.4V35.4c0-5.7,4.7-10.4,10.4-10.4h30.8c1.9,0,3.5-1.6,3.5-3.5S51.3,18,49.4,18H18.6C9,18.1,1.3,25.8,1.2,35.4v90.4c0,9.6,7.8,17.3,17.3,17.3h97.3c9.6,0,17.3-7.8,17.3-17.3V95C133.2,93,131.7,91.5,129.8,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,9.1c-6.1-6.1-16-6.1-22.1,0L47.9,71c-0.4,0.4-0.7,0.9-0.9,1.5l-8.1,29.4c-0.3,1.2,0,2.5,0.9,3.4c0.9,0.9,2.2,1.2,3.4,0.9L72.5,98c0.6-0.2,1.1-0.5,1.5-0.9l0.2-0.2l61.7-61.7c6.1-6.1,6.1-16,0-22.1L131.8,9.1z M52.2,79.8l13,13l-18,5L52.2,79.8z M71.8,94.5L71.8,94.5l2.3,2.3L71.8,94.5z M71.8,89.6L55.5,73.2l50.6-50.6l16.3,16.3L71.8,89.6z M131,30.4l-3.7,3.7L111,17.7l3.7-3.7c3.4-3.4,8.9-3.4,12.3,0l4.1,4.1C134.4,21.5,134.4,27,131,30.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/icon-notes.635b9abb3675fed90ecbd0fcc6a63718.svg";
export { ForwardRef as ReactComponent };